module.exports = __webpack_public_path__ + "static/media/adminU.12c770e7.png";